export const MISSING_HUBSPOT_SITE_MESSAGE = 'Unable to open this order because the franchise site was not provided. Please open the order again from HubSpot or contact support.';

export function parsePositiveSiteId(value) {
  const raw = String(value ?? '').trim();
  if (!/^\d+$/.test(raw)) return null;
  const siteId = Number(raw);
  return siteId > 0 ? siteId : null;
}

export function resolveOrderEditorSiteId({ urlStoreId, userSiteId, isHubSpotLaunch }) {
  const urlSiteId = parsePositiveSiteId(urlStoreId);
  if (urlSiteId) return { siteId: urlSiteId, error: null };

  if (isHubSpotLaunch) {
    return { siteId: null, error: MISSING_HUBSPOT_SITE_MESSAGE };
  }

  return { siteId: parsePositiveSiteId(userSiteId), error: null };
}